import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from 'state/modal/modalSlice';
import { editElement, editElementProp } from 'state/fence/fenceSlice';
import { getCurrentFenceGroup } from 'state/fence/fenceSelector';
import { currentBrick, elementNames } from 'helpers/globals';
import { widthInCm, widthInBrick, getItemById, getItemIndexById } from 'helpers/utils';
import ModalBase from 'components/common/ModalBase/ModalBase';
import FormLabel from 'components/common/FormLabel/FormLabel';
import FormNumber from 'components/common/FormNumber/FormNumber';
import FormCheck from 'components/common/FormCheck/FormCheck';
import ButtonBase from 'components/common/ButtonBase/ButtonBase';

let elementOldProps;

const ModalEditElement = () => {
  const dispatch = useDispatch();
  const currentFenceGroup = useSelector(getCurrentFenceGroup);
  const modal = useSelector((state) => state.modal);
  const currentIndex = getItemIndexById(currentFenceGroup.elements, modal.props.id);
  const currentElement = getItemById(currentFenceGroup.elements, modal.props.id);

  if (!elementOldProps) {
    elementOldProps = { ...currentElement };
  }

  const editElementPropHandler = (index, prop, value) => {
    if (currentElement[prop] === value) return;

    dispatch(editElementProp({ index, prop, value }));
  };

  const onChangeColumnBrickCountVertically = (value) => {
    editElementPropHandler(currentIndex, 'brickCountVertically', value);
  };

  const onChangeColumnCountHorizontally = (value) => {
    editElementPropHandler(currentIndex, 'brickCountHorizontally', widthInBrick(value));
  };

  const onChangeDoorCmHorizontally = (value) => {
    editElementPropHandler(currentIndex, 'cmHorizontally', value);
  };

  const onChangeDoorType = (value) => {
    editElementPropHandler(currentIndex, 'type', value);
  };

  const saveElement = () => {
    dispatch(closeModal());
    elementOldProps = null;
  };

  const resetNewElement = () => {
    dispatch(closeModal());
    dispatch(
      editElement({
        index: currentIndex,
        element: elementOldProps,
      })
    );
    elementOldProps = null;
  };

  const modalForm = () => {
    if (currentElement.name === 'door') {
      return (
        <>
          <div className="row align-items-center mb-xs">
            <div className="col-6">
              <FormLabel>Szélesség:</FormLabel>
            </div>
            <div className="col-6">
              <FormNumber
                defaultValue={currentElement.cmHorizontally}
                onChange={onChangeDoorCmHorizontally}
                step="1"
                min="30"
                max="500"
                unit="cm"
                typeable
              />
            </div>
          </div>

          <div className="row align-items-center mb-md">
            <div className="col-4">
              <FormLabel>Kapu nyitás:</FormLabel>
            </div>
            <div className="col-8">
              <div className="row">
                <div className="col-6">
                  <FormCheck mode="box"
                    type="radio"
                    name="door-type"
                    groupValue={currentElement.type}
                    value="simple"
                    onChange={onChangeDoorType}
                  >
                    Egyszárnyú
                  </FormCheck>
                </div>
                <div className="col-6">
                  <FormCheck mode="box"
                    type="radio"
                    name="door-type"
                    groupValue={currentElement.type}
                    value="double"
                    onChange={onChangeDoorType}
                  >
                    Kétszárnyú
                  </FormCheck>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }

    return (
      <>
        <div className="row align-items-center mb-xs">
          <div className="col-6">
            <FormLabel>Magasság:</FormLabel>
          </div>
          <div className="col-6">
            <FormNumber
              defaultValue={currentElement.brickCountVertically}
              onChange={onChangeColumnBrickCountVertically}
              step="1"
              min="1"
              max="15"
              unit="sor"
            />
          </div>
        </div>

        <div className="row align-items-center mb-md">
          <div className="col-6">
            <FormLabel>Szélesség:</FormLabel>
          </div>
          <div className="col-6">
            <FormNumber
              defaultValue={widthInCm(currentElement.brickCountHorizontally)}
              onChange={onChangeColumnCountHorizontally}
              step={currentBrick.halfBrick.width}
              min={currentElement.name === 'fundament' ? currentBrick.normalBrick.width : currentBrick.halfBrick.width}
              max={currentBrick.halfBrick.width * 40}
              unit="cm"
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <ModalBase title={`${elementNames[currentElement.name]} szerkesztése`}>
      {modalForm()}

      <div className="row">
        <div className="col-6">
          <ButtonBase color="primary" className="w-full" onClick={saveElement}>
            Mentés
          </ButtonBase>
        </div>

        <div className="col-6">
          <ButtonBase className="w-full" onClick={resetNewElement}>
            Mégsem
          </ButtonBase>
        </div>
      </div>
    </ModalBase>
  );
};

export default ModalEditElement;
